<script>
import { ResetsPage } from 'clockvine-vue';

export default {
    mixins: [
        new ResetsPage()
    ],
    methods: {
        filterSummary(pagination) {
            return `Showing ${pagination.from ?? 0}–${pagination.to ?? 0} of ${pagination.total ?? 0} result${pagination.total == 1 ? '' : 's'}.`;
        },
    },
};
</script>